module.exports = __webpack_public_path__ + "static/media/people7.3baff0e1.jpeg";